/**
 * Vehicle odometer unit values
 */
export enum VehicleOdometerUnitEnum {
	KM = 'km',
	MI = 'mi',
}
